import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import * as FaIcons from "react-icons/fa";
import { getReactAppUrl} from "../../functions/getEnv";

const blobSas = import.meta.env.VITE_BLOB_SAS;

const LeloFormRow = ({ info, visibleColumns, currentStatus }) => {
  const navigate = useNavigate();
  const {
    _id,
    createdAt,
    status,
    firstName,
    lastName,
    studentEmail,
    studentPrimaryPhone,
    learningCenters,
    uploadedUrl,
    uploadedPdfs,
    permaLink,
    _uuid,
    LeloRegistrationProfile,
  } = info;

  const appUrl = getReactAppUrl(import.meta.env.VITE_NODE_ENV);

  const [copiedId, setCopiedId] = useState(null);

  const handleCopy = (_id, permaLink, _uuid, LeloRegistrationProfile) => {
    const PermaLink = `${appUrl}/forms/${permaLink}/${_uuid}`;
    navigator.clipboard.writeText(PermaLink);
    setCopiedId(_id);
    setTimeout(() => setCopiedId(null), 1000);
  };

  // Helper function to check if a column is visible
  const isColumnVisible = (columnName) => {
    if (!visibleColumns) return true;
    return visibleColumns[columnName] !== false;
  };

  // Determine if signed agreement column should show based on status
  const showSignedAgreement = currentStatus !== "Active" && isColumnVisible("uploadedUrl");

  return (
    <tr onClick={() => navigate(`/lelo-forms/${_id}`)}>
      {isColumnVisible("createdAt") && (
        <td>{moment(createdAt).format("MM/DD/YYYY")}</td>
      )}
      {isColumnVisible("status") && (
        <td>{status}</td>
      )}
      {isColumnVisible("firstName") && (
        <td>{`${firstName} ${lastName}`}</td>
      )}
      {isColumnVisible("learningCenters") && (
        <td>{learningCenters}</td>
      )}
      {isColumnVisible("studentPrimaryPhone") && (
        <td>{studentPrimaryPhone}</td>
      )}
      {isColumnVisible("studentEmail") && (
        <td>{studentEmail}</td>
      )}
      {showSignedAgreement && (
        <td className="download-cell">
          {(() => {
            if (uploadedPdfs && uploadedPdfs.length > 0) {
              // New format: multiple PDFs stored - show icon for each PDF
              return uploadedPdfs.map((pdf, index) => (
                <a
                  key={index}
                  href={`${pdf.url}?${blobSas}`}
                  download
                  target="_blank"
                  className="download-link"
                  onClick={(e) => e.stopPropagation()}
                  style={{ marginRight: '8px' }}
                >
                  <FaIcons.FaDownload className="menu-icon" />
                </a>
              ));
            } else if (uploadedUrl) {
              // Old format: only one PDF stored - show single icon
              return (
                <a
                  href={`${uploadedUrl}?${blobSas}`}
                  download
                  target="_blank"
                  className="download-link"
                  onClick={(e) => e.stopPropagation()}
                >
                  <FaIcons.FaDownload className="menu-icon" />
                </a>
              );
            }
            return null;
          })()}
        </td>
      )}
      {isColumnVisible("permaLink") && (
        <td className="copy-cell">
          {copiedId === _id && (
            <div className="copy-tooltip">
              Copied!
            </div>
          )}
          <button
            className={`btn btn-llac-light-grey copy-button`}
            onClick={(e) => {
              e.stopPropagation();
              handleCopy(_id, permaLink, _uuid, LeloRegistrationProfile);
            }}
          >
            Copy Registration Link
          </button>
        </td>
      )}
    </tr>
  );
};

export default LeloFormRow;
